export type BackgroundType =
  | "image/svg"
  | "image/png"
  | "image/jpeg"
  | "image/webp";

export interface Background {
  id: string;
  name: string;
  type: BackgroundType;
  updatedOn: Date;
}
